import { tassign } from 'tassign';
import { Actions, ActionTypes } from './global-filters-store.actions';
import { initialState, State } from './global-filters-store.state';

export function globalFilterReducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.setSic:
      return tassign(state, {
        sic: action.payload.sic,
      });

    case ActionTypes.setSicLatLng:
      return tassign(state, {
        sicLatLng: action.payload.sicLatLng,
      });

    case ActionTypes.setPlanDate:
      return tassign(state, {
        planDate: action.payload.planDate,
      });

    default: {
      return state;
    }
  }
}
